/* Holland Padel – Halloween-cadeau (t/m 31-10-2026).
   In de winkelwagen (drawer + /cart) een veld "Actiecode". Vult de klant HALLOWEEN in
   (of staat de code al op de wagen) en is de bestelling (zonder cadeau) minimaal €150,
   dan kiest de klant 1 gratis cadeau: 4on Totaalgrip Spray 100 ml of een Floky armsleeve.
   Altijd maximaal 1 cadeau (regel met eigenschap _hp_halloween, aantal 1).
   De korting zelf zit in Shopify (code HALLOWEEN, Buy X get Y). */
(function () {
  var EINDE = new Date('2026-10-31T23:59:59+01:00');
  var aan = window.HP_HW_LIVE === true || (function () { try { return localStorage.getItem('hpHwTest') === '1'; } catch (e) { return false; } })();
  if (!aan || new Date() > EINDE) return;

  var CODE = 'HALLOWEEN', DREMPEL = 15000, PROP = '_hp_halloween';
  var CADEAUS = [
    { handle: 'spray-40n-totaalgrip', naam: '4on Totaalgrip Spray 100 ml' },
    { handle: 'floky-no-strain-evolution-armsleeve-1-pack-padel-accessoires', naam: 'Floky No Strain armsleeve' }
  ];
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var producten = null, bezig = false, codeIngevuld = false, melding = '';

  function euro(c) { return '€' + (c / 100).toFixed(2).replace('.', ','); }
  function post(url, body) {
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  function wagen() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function laadProducten() {
    if (producten) return Promise.resolve(producten);
    return Promise.all(CADEAUS.map(function (c) {
      return fetch(root + 'products/' + c.handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
        return { naam: c.naam, img: p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '', varianten: p.variants.filter(function (v) { return v.available; }) };
      });
    })).then(function (l) { producten = l; return l; });
  }
  function isCadeau(i) { return i.properties && i.properties[PROP]; }
  function heeftCode(cart) {
    return (cart.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === CODE; });
  }
  function verversDrawer() { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh')); }
  function verversPagina() { if (/\/cart\/?$/.test(location.pathname)) location.reload(); else verversDrawer(); }

  function css() {
    if (document.getElementById('hp-hw-css')) return;
    var s = document.createElement('style'); s.id = 'hp-hw-css';
    s.textContent = [
      '.hp-hw{border:1px solid rgba(0,0,0,.12);border-radius:8px;padding:14px;margin:0 0 16px;font-size:14px;text-align:left}',
      '.hp-hw .hp-hw__rij{display:flex!important;gap:8px;margin:0}',
      '.hp-hw .hp-hw__rij input{flex:1 1 auto!important;min-width:0;width:auto!important;height:44px!important;margin:0!important;padding:0 12px!important;border:1px solid rgba(0,0,0,.3)!important;border-radius:6px!important;font-size:14px!important;text-transform:uppercase}',
      '.hp-hw .hp-hw__rij input::placeholder{text-transform:none}',
      '.hp-hw button.hp-hw__knop{display:inline-flex!important;align-items:center;justify-content:center;height:44px!important;margin:0!important;padding:0 18px!important;border-radius:6px!important;border:0!important;background:#111!important;color:#fff!important;font-weight:700!important;font-size:13px!important;letter-spacing:.04em;text-transform:uppercase;cursor:pointer;white-space:nowrap;flex:none}',
      '.hp-hw button.hp-hw__knop--klein{height:36px!important;padding:0 14px!important}',
      '.hp-hw .hp-hw__kop{font-weight:700;margin:0 0 6px;font-size:14px}.hp-hw .hp-hw__sub{margin:0 0 10px;opacity:.75;font-size:13px;line-height:1.4}',
      '.hp-hw .hp-hw__opties{display:grid;gap:8px}',
      '.hp-hw .hp-hw__optie{display:flex;align-items:center;gap:10px;border:1px solid rgba(0,0,0,.12);border-radius:6px;padding:8px}',
      '.hp-hw .hp-hw__optie img{width:52px;height:52px;object-fit:contain;flex:none;margin:0}',
      '.hp-hw .hp-hw__naam{flex:1;line-height:1.3;font-size:13px;font-weight:600}',
      '.hp-hw .hp-hw__naam select{display:block;margin-top:6px;height:32px;font-size:13px;font-weight:400;max-width:100%;padding:0 28px 0 8px;border:1px solid rgba(0,0,0,.3);border-radius:4px}',
      '.hp-hw .hp-hw__ok{color:#1a7f37;font-weight:600;margin:0 0 4px}.hp-hw .hp-hw__fout{margin:8px 0 0;font-size:13px}',
      '.hp-hw button.hp-hw__wissel{background:none!important;border:0!important;padding:0!important;margin:0;text-decoration:underline;cursor:pointer;font-size:13px;color:inherit!important;height:auto!important}',
      '.hp-hw[aria-busy=true]{opacity:.6;pointer-events:none}'].join('');
    document.head.appendChild(s);
  }

  function blokken() {
    var uit = [];
    document.querySelectorAll('button[name="checkout"]').forEach(function (b) {
      var houder = b.parentElement; if (!houder || !houder.parentElement) return;
      var blok = houder.parentElement.querySelector(':scope > .hp-hw');
      if (!blok) { blok = document.createElement('div'); blok.className = 'hp-hw'; houder.parentElement.insertBefore(blok, houder); }
      uit.push(blok);
    });
    return uit;
  }

  function teken(cart, kiesModus) {
    var lijst = blokken(); if (!lijst.length) return;
    var items = cart.items || [];
    if (!items.length) { lijst.forEach(function (b) { b.hidden = true; }); return; }
    var cadeau = items.find(isCadeau);
    var sub = items.reduce(function (t, i) { return isCadeau(i) ? t : t + i.final_line_price; }, 0);
    var code = heeftCode(cart) || codeIngevuld;
    var html;
    if (!code) {
      html = '<p class="hp-hw__kop">Actiecode</p><div class="hp-hw__rij" data-hw="code"><input data-hw-c="1" enterkeyhint="done" placeholder="Vul je code in" autocomplete="off" aria-label="Actiecode"><button type="button" class="hp-hw__knop" data-hw="pas">Toepassen</button></div>' +
        (melding ? '<p class="hp-hw__fout">' + melding + '</p>' : '');
    } else if (sub < DREMPEL) {
      html = '<p class="hp-hw__kop">🎃 Code HALLOWEEN staat erop</p><p class="hp-hw__sub" style="margin:0">Nog ' + euro(DREMPEL - sub) + ' tot je gratis cadeau. Vanaf €150 kies je een gratis grip-spray of Floky armsleeve.</p>';
    } else if (cadeau && !kiesModus) {
      html = '<p class="hp-hw__kop">🎃 Code HALLOWEEN staat erop</p><p class="hp-hw__ok" style="margin:0">✓ Gratis cadeau: ' + cadeau.product_title + (cadeau.variant_title ? ' (' + cadeau.variant_title + ')' : '') + '</p>' +
        '<button type="button" class="hp-hw__wissel" data-hw="wissel">Ander cadeau kiezen</button>';
    } else {
      html = '<p class="hp-hw__kop">🎃 Kies je gratis Halloween-cadeau</p><p class="hp-hw__sub">Eén cadeau per bestelling. Het wordt meteen €0.</p><div class="hp-hw__opties">' +
        (producten || []).map(function (p, n) {
          if (!p.varianten.length) return '';
          var sel = p.varianten.length > 1 ? '<select data-hw-v="' + n + '" aria-label="Kies kleur en maat">' + p.varianten.map(function (v) { return '<option value="' + v.id + '">' + v.title + '</option>'; }).join('') + '</select>' : '';
          return '<div class="hp-hw__optie"><img src="' + p.img + '" alt="" width="52" height="52"><div class="hp-hw__naam">' + p.naam + sel + '</div>' +
            '<button type="button" class="hp-hw__knop hp-hw__knop--klein" data-hw="kies" data-n="' + n + '" data-id="' + p.varianten[0].id + '">Kies</button></div>';
        }).join('') + '</div>';
    }
    lijst.forEach(function (b) { b.hidden = false; if (b.dataset.html !== html) { b.innerHTML = html; b.dataset.html = html; } });
  }

  function kies(variantId) {
    bezig = true; zetBezig(true);
    wagen().then(function (cart) {
      var updates = {};
      cart.items.forEach(function (i) { if (isCadeau(i)) updates[i.key] = 0; });
      var stap = Object.keys(updates).length ? post('cart/update.js', { updates: updates }) : Promise.resolve();
      return stap.then(function () { return post('cart/add.js', { items: [{ id: Number(variantId), quantity: 1, properties: (function () { var o = {}; o[PROP] = '1'; return o; })() }] }); })
        .then(function () { return heeftCode(cart) ? null : post('cart/update.js', { discount: CODE }); });
    }).then(function () { bezig = false; verversPagina(); return controleer(); })
      .catch(function () { bezig = false; zetBezig(false); });
  }
  function zetBezig(j) { document.querySelectorAll('.hp-hw').forEach(function (b) { b.setAttribute('aria-busy', j ? 'true' : 'false'); }); }

  function controleer(kiesModus) {
    if (bezig) return Promise.resolve();
    return wagen().then(function (cart) {
      var cadeaus = cart.items.filter(isCadeau);
      var sub = cart.items.reduce(function (t, i) { return isCadeau(i) ? t : t + i.final_line_price; }, 0);
      var aantal = cadeaus.reduce(function (t, i) { return t + i.quantity; }, 0);
      if (aantal && (sub < DREMPEL || aantal > 1)) {
        var variant = cadeaus[0].variant_id;
        bezig = true;
        var weg = cadeaus.reduce(function (pr, i) { return pr.then(function () { return post('cart/change.js', { id: i.key, quantity: 0 }); }); }, Promise.resolve());
        return weg.then(function () {
          if (sub < DREMPEL) return null;
          var o = {}; o[PROP] = '1';
          return post('cart/add.js', { items: [{ id: variant, quantity: 1, properties: o }] });
        }).then(function () { bezig = false; verversPagina(); }, function () { bezig = false; });
      }
      var toon = function () { teken(cart, kiesModus); zetBezig(false); };
      if (heeftCode(cart) || codeIngevuld) return laadProducten().then(toon, toon);
      toon();
    }).catch(function () {});
  }

  function pasToe(rij) {
    var inp = rij.querySelector('[data-hw-c]'); var c = (inp.value || '').trim().toUpperCase(); if (!c) return;
    zetBezig(true);
    post('cart/update.js', { discount: c }).then(function (cart) {
      if (c === CODE) { codeIngevuld = true; melding = ''; }
      else { melding = 'Code ' + c + ' is toegevoegd. Je ziet de korting bij het afrekenen.'; }
      return laadProducten().then(function () { teken(cart); zetBezig(false); });
    }).catch(function () { zetBezig(false); });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches || !e.target.matches('[data-hw-c]')) return;
    e.preventDefault(); e.stopPropagation(); pasToe(e.target.closest('[data-hw="code"]'));
  }, true);
  document.addEventListener('click', function (e) {
    var p = e.target.closest && e.target.closest('[data-hw="pas"]');
    if (p) { e.preventDefault(); pasToe(p.closest('[data-hw="code"]')); return; }
    var k = e.target.closest && e.target.closest('[data-hw="kies"]');
    if (k) { e.preventDefault(); var sel = k.parentElement.querySelector('select'); kies(sel ? sel.value : k.dataset.id); return; }
    if (e.target.closest && e.target.closest('[data-hw="wissel"]')) controleer(true);
  });
  ['on:cart:add', 'on:line-item:change', 'on:cart-drawer:after-open', 'on:cart-drawer:after-refresh'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(controleer, 300); });
  });
  new MutationObserver(function () {
    var mist = Array.prototype.some.call(document.querySelectorAll('button[name="checkout"]'), function (b) {
      return b.parentElement && b.parentElement.parentElement && !b.parentElement.parentElement.querySelector(':scope > .hp-hw');
    });
    if (mist) controleer();
  }).observe(document.documentElement, { childList: true, subtree: true });
  css();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { controleer(); }); else controleer();
})();
